import { useEffect } from 'react'

export function useOverlayMode(enabled: boolean) {
  useEffect(() => {
    const ELEMENT = document.body

    ELEMENT.classList.toggle('overflow-hidden', enabled)
  }, [enabled])
}
